import { render, staticRenderFns } from "./DiscussBrowsing.vue?vue&type=template&id=6b089870&scoped=true"
import script from "./DiscussBrowsing.vue?vue&type=script&lang=js"
export * from "./DiscussBrowsing.vue?vue&type=script&lang=js"
import style0 from "./DiscussBrowsing.vue?vue&type=style&index=0&id=6b089870&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b089870",
  null
  
)

export default component.exports